module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('category-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.distributor_id
    },
    on: {
      "update": _vm.storeSearch
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    },
    slot: "reference"
  }, [_vm._v("添加分类")]), _vm._v(" "), (_vm.distributor_id > 1) ? _c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.syncAction()
      }
    },
    slot: "reference"
  }, [_vm._v("\n      同步当前店铺分类到指定店铺\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "multipleItemsTable",
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.list,
        "height": _vm.wheight - 240
      },
      on: {
        "selection-change": _vm.handleItemsSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "width": "55"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "category_name",
        "label": "分类名称",
        "min-width": "200"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "分类状态(显示/隐藏)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            on: {
              "change": function($event) {
                return _vm.changeStatus(scope.row)
              }
            },
            model: {
              value: (scope.row.status),
              callback: function($$v) {
                _vm.$set(scope.row, "status", $$v)
              },
              expression: "scope.row.status"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "is_point",
        "label": "排序",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "placeholder": "分类排序"
            },
            on: {
              "blur": function($event) {
                return _vm.sortblur($event, scope.row)
              }
            },
            model: {
              value: (scope.row.sort),
              callback: function($$v) {
                _vm.$set(scope.row, "sort", $$v)
              },
              expression: "scope.row.sort"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "min-width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.edit(scope.row)
              }
            },
            slot: "reference"
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.deldialog(scope.row)
              }
            },
            slot: "reference"
          }, [_vm._v("删除\n            ")])]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded content-center"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pagesize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "分类名称"
    },
    model: {
      value: (_vm.form.category_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_name", $$v)
      },
      expression: "form.category_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "排序"
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "同步至其他店铺"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.isSyncAll),
      callback: function($$v) {
        _vm.$set(_vm.form, "isSyncAll", $$v)
      },
      expression: "form.isSyncAll"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.SyncDataTitle,
      "visible": _vm.syncDataVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.syncDataVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.syncForm,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "指定店铺"
      }
    }, [(_vm.relDistributors.length > 0) ? _c('el-tag', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "size": "mini",
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.closeAll()
        }
      }
    }, [_vm._v("清空全部\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.relDistributors), function(item, index) {
      return _c('el-tag', {
        key: item.distributor_id,
        staticClass: "new-tag",
        attrs: {
          "closable": "",
          "disable-transitions": false
        },
        on: {
          "close": function($event) {
            return _vm.handleClose(index)
          }
        }
      }, [_vm._v(" " + _vm._s(item.name) + "\n          ")])
    }), _vm._v(" "), _c('el-button', {
      staticClass: "button-new-tag",
      attrs: {
        "size": "medium"
      },
      on: {
        "click": _vm.addDistributoreAction
      }
    }, [_vm._v("+ 点击搜索店铺")])], 2), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "按标签同步"
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": "店铺标签"
      },
      model: {
        value: (_vm.tag_ids),
        callback: function($$v) {
          _vm.tag_ids = $$v
        },
        expression: "tag_ids"
      }
    }, _vm._l((_vm.distributor_tags), function(item) {
      return _c('el-option', {
        key: item.tag_id,
        attrs: {
          "label": item.tag_name,
          "value": item.tag_id
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n        注意：同步分类时会先删除门店原有分类数据，然后以当前门店分类为基准重新建立新的分类数据"), _c('br')])], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.syncDataVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": function($event) {
          return _vm.syncAll()
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.submitLoading ? '同步中' : '确认开始同步') + "\n      ")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.delVisible,
      "width": "30%",
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.delVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "指定店铺标签"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "店铺标签"
    },
    model: {
      value: (_vm.tag_ids),
      callback: function($$v) {
        _vm.tag_ids = $$v
      },
      expression: "tag_ids"
    }
  }, _vm._l((_vm.distributor_tags), function(item) {
    return _c('el-option', {
      key: item.tag_id,
      attrs: {
        "label": item.tag_name,
        "value": item.tag_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.isSyncAll),
      callback: function($$v) {
        _vm.$set(_vm.form, "isSyncAll", $$v)
      },
      expression: "form.isSyncAll"
    }
  }), _vm._v("   同时删除指定标签下店铺的分类数据\n      ")], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("注意：如果当前分类下已有关联商品，则会先删除分类然后将其下商品重置为未分类。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.delVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.del()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.DistributorVisible,
      "rel-data-ids": _vm.relDistributors,
      "get-status": _vm.DistributorStatus
    },
    on: {
      "chooseStore": _vm.DistributorChooseAction,
      "closeStoreDialog": _vm.closeDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59851e68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59851e68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/categorylist.vue
// module id = 2741
// module chunks = 0